import { client } from '../config/palantirClient';
import { gql, useQuery, useLazyQuery } from '@apollo/client';
import get from 'lodash/get';

export const USER_REVIEW_ROCKET_ID = gql`
  query GetUserReviewRocketId($userUid: UUID!) {
    user(uid: $userUid) {
      reviewRocketId
    }
  }
`;

export const SKYHOOK_PERMISSIONS = gql`
  query SkyhookPermissions {
    skyhookPermissions {
      id: slug
      slug
      authorized
    }
  }
`;

export const PARTNER_PERMISSIONS = gql`
  query PartnerPermissions {
    partnerPermissions {
      id: slug
      slug
      authorized
    }
  }
`;

export const ORGANIZATION_PERMISSIONS = gql`
  query OrganizationPermissions {
    organizationPermissions {
      id: slug
      slug
      authorized
    }
  }
`;

export const DEFAULT_PERMISSIONS = gql`
  query DefaultPermissions {
    defaultPermissions {
      id: slug
      slug
      authorized
    }
  }
`;

export const SUPPORT_PERMISSIONS = gql`
  query SupportPermissions {
    supportPermissions {
      permission
    }
  }
`;

export const CAN_MOCK = gql`
  query CanMock($userUID: UUID!) {
    canMock(userUID: $userUID)
  }
`;

export async function userReviewRocketId(userUid) {
  const {
    data: {
      user: { reviewRocketId },
    },
  } = await client.query({
    query: USER_REVIEW_ROCKET_ID,
    variables: { userUid },
  });
  return reviewRocketId;
}

export function skyhookPermissions() {
  return client.query({ query: SKYHOOK_PERMISSIONS });
}

export function partnerPermissions() {
  return client.query({ query: PARTNER_PERMISSIONS });
}

export function organizationPermissions() {
  return client.query({ query: ORGANIZATION_PERMISSIONS });
}

export function defaultPermissions() {
  return client.query({ query: DEFAULT_PERMISSIONS });
}

export function supportPermissions() {
  return client.query({ query: SUPPORT_PERMISSIONS });
}

export const usePartnerPermission = () => {
  const {
    data,
    loading: partnerPermissionsLoading,
    error: partnerPermissionsError,
  } = useQuery(PARTNER_PERMISSIONS);

  const permissions = get(data, 'partnerPermissions', []);
  const partnerPermissionsData = permissions.reduce(
    (acc, { slug, authorized }) => {
      return { ...acc, [slug]: authorized };
    },
    {}
  );

  return {
    partnerPermissionsData,
    partnerPermissionsLoading,
    partnerPermissionsError,
  };
};

export function useCanMockQuery() {
  return useLazyQuery(CAN_MOCK);
}
